import { t } from '@lingui/macro';
import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';

import {
    CERTIFICATE_NAME_FIELD,
    CERTIFICATE_USAGE_FIELD,
    CERTIFICATE_DESCRIPTION_FIELD,
    TAB_CERTIFICATES,
} from './CertificateConstants';
import { SELECTIONMODE_MULTI } from '../../data-table/SelectionContext';
import DataTable from '../../data-table/DataTable';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { getUrlParamFromState } from '../../../utilities/PageStateUrlUtilities';
import { useQueryLoader } from '../../data-table/Loaders';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { AdminPages, buildPageTarget } from '../AdminLinkUtils';

const functionName = AdminPages.AgentCertificates;

function getColumns(activeTab) {
    const detailTarget = `${buildPageTarget(functionName)}?${getUrlParamFromState({ activeTab })}`;
    return activeTab === TAB_CERTIFICATES
        ? [
              {
                  type: COLUMN_TYPES.LINK,
                  mapping: CERTIFICATE_NAME_FIELD,
                  title: t`Name`,
                  sortable: true,
                  width: 250,
                  link: {
                      sysAdminOnly: true,
                      target: detailTarget,
                  },
              },
              {
                  type: COLUMN_TYPES.TEXT,
                  mapping: CERTIFICATE_USAGE_FIELD,
                  title: t`Usage`,
                  sortable: true,
                  width: 300,
              },
              {
                  type: COLUMN_TYPES.TEXT,
                  mapping: CERTIFICATE_DESCRIPTION_FIELD,
                  title: t`Description`,
                  sortable: true,
                  width: 300,
              },
          ]
        : [
              {
                  type: COLUMN_TYPES.LINK,
                  mapping: CERTIFICATE_NAME_FIELD,
                  title: t`Name`,
                  sortable: true,
                  width: 400,
                  link: {
                      target: detailTarget,
                  },
              },
              {
                  type: COLUMN_TYPES.TEXT,
                  mapping: CERTIFICATE_DESCRIPTION_FIELD,
                  title: t`Description`,
                  sortable: true,
                  flex: 1,
              },
          ];
}

const initialSort = [{ property: CERTIFICATE_NAME_FIELD, direction: SORT_ASC }];

const useStyles = makeStyles((theme) => ({
    tabTable: {
        paddingTop: theme.spacing(1),
        '@media print': {
            paddingTop: 0,
        },
    },
}));

export default function CertificateListPanel(props) {
    const { triggerRef, tableState, dataSource, activeTab } = props;
    const loader = useQueryLoader(dataSource, { disableFilterState: true });

    const columns = useMemo(() => getColumns(activeTab), [activeTab]);

    const classes = useStyles();

    return (
        <DataTable
            key={activeTab} // Reset table state when activeTab changes
            className={classes.tabTable}
            tableId={`certificates-${activeTab}-table`}
            loader={loader}
            columns={columns}
            triggerRef={triggerRef}
            visibleRows={0}
            sorters={initialSort}
            onStateChanged={tableState.setTableState}
            showSelectionColumn
            disableColumnRemover
            selectionOptions={{
                mode: SELECTIONMODE_MULTI,
                allowSelectAll: true,
                idMapping: '_id',
                onChange: tableState.setSelection,
            }}
        />
    );
}
